<template>
  <div id="tab">
    <div class="tab-bar flex">
        <slot>
        </slot>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'tab'
    }
</script>
<style scoped>
    .flex {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
    }
    
    .flex_warp {
        -webkit-box-lines: multiple;
        -webkit-flex-wrap: wrap;
        -moz-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -o-flex-wrap: wrap;
        flex-wrap: wrap;
        box-sizing: border-box;
        align-content: flex-start;
    }
    
    .flex_w_center {
        justify-content: center;
    }
    
    .flex_h_center {
        align-items: baseline;
    }
    
    .flex_w_center1 {
        justify-content: space-between;
    }
    
    .txtnowarp {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .tab-bar {
        width: 100%;
        height: 60px;
    }
</style>